export default {
  metaDescription: 'TEF menyediakan solusi fabrikasi vessel, piping, peralatan pemanas dan lainnya, serta layanan perawatan dan rekondisi termasuk retubing dan re-shelling.',
  pageTitle: 'Layanan',
  expertise: {
    title: 'Keunggulan Kami',
    description:
      '<strong>PT TOKKI ENGINEERING AND FABRICATION</strong> berkomitmen untuk menghadirkan produk berkualitas tinggi dan layanan purna jual teknis terbaik dari Indonesia untuk pelanggan di seluruh dunia. Sebagai perusahaan yang berspesialisasi dalam <strong>fabrikasi bejana tekan las dan sheet metal</strong>, kami mendukung infrastruktur industri di sektor <strong>Minyak & Gas, Petrokimia, Farmasi, Pupuk, Bahan Kimia Pertanian, Pembangkit Listrik, dan industri Thermal Processing</strong>.',
  },
  fabricationSolutions: {
    heading: 'Solusi Fabrikasi',
    intro: 'Kami memproduksi berbagai peralatan industri, di antaranya:',
    cards: {
      vessels: { title: 'Pressure Vessels', desc: 'Reaktor, tangki, menara, dan heat exchanger.' },
      piping: { title: 'Sistem Perpipaan Prafabrikasi', desc: 'untuk pemasangan yang efisien di pabrik petrokimia dan farmasi.' },
      heating: { title: 'Peralatan Pemanas Industri', desc: 'Muffle, radiant tube, rotary kiln, tray, dan basket.' },
      etc: { title: 'Dan Lain-lain', desc: 'Seluruh peralatan fabrikasi.' },
    },
  },
  maintenance: {
    heading: 'Pemeliharaan dan Rekondisi',
    description:
      'Selain fabrikasi baru, kami juga menyediakan layanan pemeliharaan dan rekondisi, baik di bengkel kami maupun langsung di lokasi pelanggan (on-site), untuk memperpanjang usia pakai dan performa peralatan Anda.',
    buttons: {
      retubing: 'Re-tubing untuk Heat Exchanger',
      pipelineRepairs: 'Perbaikan & Servis Pipeline',
      onSiteMaintenance: 'Pemeliharaan On-site & di Bengkel',
      etc: 'Dan Lain-lain',
    },
  },
};
